import client from '../base-api';

const serviceURL = '/company-settings';

const companySettingsService = {
    saveSettings(body: any) {
        return client.post(`${serviceURL}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    getSettings() {
        return client.get(`${serviceURL}`);
    },
}

export default companySettingsService;